/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserContextOutput } from './userContextOutput';

export type UserContext = UserContextOutput | null;
